var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "position": "relative",
      "z-index": "1"
    }
  }, [_c('div', {
    staticClass: "flex mb-2 justify-between"
  }, [_c('div'), _c('Tag', {
    on: {
      "click": _vm.toggleHide
    }
  }, [_vm.hide ? [_vm._v("Show All")] : [_vm._v(" Hide Unused")]], 2)], 1), _vm._l(_vm.definitions, function (definition) {
    return _c('div', {
      key: definition.key,
      staticClass: "pb-1",
      staticStyle: {
        "min-width": "15rem"
      }
    }, [definition.type == 'string' ? [_c('YInput', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.hide || _vm.inputs[definition.key],
        expression: "!hide || inputs[definition.key]"
      }],
      attrs: {
        "id": definition.key,
        "label": definition.key,
        "required": definition.required,
        "tooltip": definition.tooltip,
        "icons": [definition.tokenSwapper ? {
          name: 'codeBraces',
          tooltip: 'Dynamic tokens enabled. Use {country}, {region}, or {city}'
        } : undefined].filter(function (icon) {
          return icon;
        })
      },
      model: {
        value: _vm.inputs[definition.key],
        callback: function ($$v) {
          _vm.$set(_vm.inputs, definition.key, $$v);
        },
        expression: "inputs[definition.key]"
      }
    }), _vm.linkedDefinitions[definition.key] ? _c('TemplateVarVariantsContainer', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.hide || _vm.inputs[definition.key],
        expression: "!hide || inputs[definition.key]"
      }],
      staticClass: "mt-1",
      attrs: {
        "variant-definitions": _vm.linkedDefinitions[definition.key],
        "inputs": _vm.inputs
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (props) {
          return [_c('YInput', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: props.show,
              expression: "props.show"
            }],
            attrs: {
              "id": props.definition.key,
              "label": props.definition.key
            },
            model: {
              value: _vm.inputs[props.definition.key],
              callback: function ($$v) {
                _vm.$set(_vm.inputs, props.definition.key, $$v);
              },
              expression: "inputs[props.definition.key]"
            }
          })];
        }
      }], null, true)
    }) : _vm._e()] : _vm._e(), definition.type == 'textarea' ? [_c('YTextarea', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.hide || _vm.inputs[definition.key],
        expression: "!hide || inputs[definition.key]"
      }],
      attrs: {
        "id": definition.key,
        "label": definition.key,
        "required": definition.required,
        "tooltip": definition.tooltip,
        "icons": [definition.tokenSwapper ? {
          name: 'codeBraces',
          tooltip: 'Dynamic tokens enabled. Use {country}, {region}, or {city}'
        } : undefined].filter(function (icon) {
          return icon;
        })
      },
      model: {
        value: _vm.inputs[definition.key],
        callback: function ($$v) {
          _vm.$set(_vm.inputs, definition.key, $$v);
        },
        expression: "inputs[definition.key]"
      }
    }), _vm.linkedDefinitions[definition.key] ? _c('TemplateVarVariantsContainer', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.hide || _vm.inputs[definition.key],
        expression: "!hide || inputs[definition.key]"
      }],
      staticClass: "mt-1",
      attrs: {
        "variant-definitions": _vm.linkedDefinitions[definition.key],
        "inputs": _vm.inputs
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (props) {
          return [_c('YTextarea', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: props.show,
              expression: "props.show"
            }],
            attrs: {
              "id": props.definition.key,
              "label": props.definition.key
            },
            model: {
              value: _vm.inputs[props.definition.key],
              callback: function ($$v) {
                _vm.$set(_vm.inputs, props.definition.key, $$v);
              },
              expression: "inputs[props.definition.key]"
            }
          })];
        }
      }], null, true)
    }) : _vm._e()] : _vm._e(), definition.type == 'colorSelect' ? [_c('div', {
      staticClass: "flex items-center gap-4"
    }, [_c('YInput', {
      staticClass: "w-full",
      attrs: {
        "label": definition.key
      },
      on: {
        "input": function ($event) {
          return _vm.updateColorValue(definition, $event);
        }
      },
      model: {
        value: _vm.inputs[definition.key],
        callback: function ($$v) {
          _vm.$set(_vm.inputs, definition.key, $$v);
        },
        expression: "inputs[definition.key]"
      }
    }), _c('verte', {
      attrs: {
        "picker": "wheel",
        "model": "hex",
        "menuPosition": "left"
      },
      on: {
        "input": function ($event) {
          return _vm.updateColorValue(definition, $event);
        }
      },
      model: {
        value: _vm.inputs[definition.key],
        callback: function ($$v) {
          _vm.$set(_vm.inputs, definition.key, $$v);
        },
        expression: "inputs[definition.key]"
      }
    })], 1)] : _vm._e(), definition.type == 'boolean' ? [_c('Superselect', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.hide || _vm.inputs[definition.key],
        expression: "!hide || inputs[definition.key]"
      }],
      attrs: {
        "id": definition.key,
        "title": definition.key,
        "multiple": false,
        "options": ['yes', 'no'],
        "tooltip": definition.tooltip
      },
      model: {
        value: _vm.inputs[definition.key],
        callback: function ($$v) {
          _vm.$set(_vm.inputs, definition.key, $$v);
        },
        expression: "inputs[definition.key]"
      }
    }), _vm.linkedDefinitions[definition.key] ? _c('TemplateVarVariantsContainer', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.hide || _vm.inputs[definition.key],
        expression: "!hide || inputs[definition.key]"
      }],
      staticClass: "mt-1",
      attrs: {
        "variant-definitions": _vm.linkedDefinitions[definition.key],
        "inputs": _vm.inputs
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (props) {
          return [_c('Superselect', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: props.show,
              expression: "props.show"
            }],
            attrs: {
              "id": props.definition.key,
              "title": props.definition.key,
              "multiple": false,
              "options": ['yes', 'no']
            },
            model: {
              value: _vm.inputs[props.definition.key],
              callback: function ($$v) {
                _vm.$set(_vm.inputs, props.definition.key, $$v);
              },
              expression: "inputs[props.definition.key]"
            }
          })];
        }
      }], null, true)
    }) : _vm._e()] : _vm._e(), definition.type == 'select' ? [_c('Superselect', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.hide || _vm.inputs[definition.key],
        expression: "!hide || inputs[definition.key]"
      }],
      attrs: {
        "id": definition.key,
        "title": definition.key,
        "multiple": false,
        "options": definition.options,
        "tooltip": definition.tooltip
      },
      model: {
        value: _vm.inputs[definition.key],
        callback: function ($$v) {
          _vm.$set(_vm.inputs, definition.key, $$v);
        },
        expression: "inputs[definition.key]"
      }
    }), _vm.linkedDefinitions[definition.key] ? _c('TemplateVarVariantsContainer', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.hide || _vm.inputs[definition.key],
        expression: "!hide || inputs[definition.key]"
      }],
      staticClass: "mt-1",
      attrs: {
        "variant-definitions": _vm.linkedDefinitions[definition.key],
        "inputs": _vm.inputs
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (props) {
          return [_c('Superselect', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: props.show,
              expression: "props.show"
            }],
            attrs: {
              "id": props.definition.key,
              "title": props.definition.key,
              "multiple": false,
              "options": props.definition.options
            },
            model: {
              value: _vm.inputs[props.definition.key],
              callback: function ($$v) {
                _vm.$set(_vm.inputs, props.definition.key, $$v);
              },
              expression: "inputs[props.definition.key]"
            }
          })];
        }
      }], null, true)
    }) : _vm._e()] : _vm._e(), definition.type == 'offer' || definition.type == 'offerFeed' ? [_c('div', [_c('OfferVarSelect', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.hide || _vm.inputs[definition.key],
        expression: "!hide || inputs[definition.key]"
      }],
      attrs: {
        "id": definition.key,
        "title": definition.key,
        "types": definition.type == 'offerFeed' ? ['feed'] : ['offer', 'campaign'],
        "required": definition.required,
        "tooltip": definition.tooltip
      },
      model: {
        value: _vm.inputs[definition.key],
        callback: function ($$v) {
          _vm.$set(_vm.inputs, definition.key, $$v);
        },
        expression: "inputs[definition.key]"
      }
    }), _vm.offerVariantDefinitions[definition.key] ? _c('TemplateVarVariantsContainer', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.hide || _vm.inputs[definition.key],
        expression: "!hide || inputs[definition.key]"
      }],
      staticClass: "mt-1",
      attrs: {
        "variant-definitions": _vm.offerVariantDefinitions[definition.key],
        "inputs": _vm.inputs
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (props) {
          return [_c('OfferVarSelect', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: props.show,
              expression: "props.show"
            }],
            attrs: {
              "id": props.definition.key,
              "title": props.definition.key,
              "types": definition.type == 'offerFeed' ? ['feed'] : undefined
            },
            model: {
              value: _vm.inputs[props.definition.key],
              callback: function ($$v) {
                _vm.$set(_vm.inputs, props.definition.key, $$v);
              },
              expression: "inputs[props.definition.key]"
            }
          })];
        }
      }], null, true)
    }) : _vm._e()], 1)] : _vm._e(), definition.type == 'image' ? [_c('Superselect', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.hide || _vm.inputs[definition.key],
        expression: "!hide || inputs[definition.key]"
      }],
      attrs: {
        "id": definition.key,
        "title": definition.key,
        "options": [],
        "track-by": "id",
        "label": "name",
        "multiple": false,
        "no-result": "Sorry, no images found.",
        "required": definition.required,
        "tooltip": definition.tooltip,
        "query": _vm.TEMPLATE_IMAGES_QUERY,
        "query-variables": {
          first: 10,
          filters: {
            name: {
              value: ['{input}'],
              modifiers: {
                matchType: 'contains'
              }
            }
          }
        }
      },
      scopedSlots: _vm._u([{
        key: "singleLabel",
        fn: function (props) {
          return [_c('div', {
            staticClass: "flex items-center"
          }, [_c('YImage', {
            staticClass: "rounded mr-2",
            attrs: {
              "src": props.option.imageThumbnailUrl,
              "width": 6,
              "height": 6
            }
          }), _c('div', [_vm._v(_vm._s(props.option.name))])], 1)];
        }
      }, {
        key: "option",
        fn: function (props) {
          return [_c('div', {
            staticClass: "flex items-center -mx-2"
          }, [_c('YImage', {
            staticClass: "rounded mr-2",
            attrs: {
              "src": props.option.imageThumbnailUrl,
              "width": 12,
              "height": 12
            }
          }), _c('div', [_vm._v(_vm._s(props.option.name))])], 1)];
        }
      }], null, true),
      model: {
        value: _vm.inputs[definition.key],
        callback: function ($$v) {
          _vm.$set(_vm.inputs, definition.key, $$v);
        },
        expression: "inputs[definition.key]"
      }
    }), _vm.linkedDefinitions[definition.key] ? _c('TemplateVarVariantsContainer', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.hide || _vm.inputs[definition.key],
        expression: "!hide || inputs[definition.key]"
      }],
      staticClass: "mt-1",
      attrs: {
        "variant-definitions": _vm.linkedDefinitions[definition.key],
        "inputs": _vm.inputs
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (props) {
          return [_c('Superselect', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: props.show,
              expression: "props.show"
            }],
            attrs: {
              "id": props.definition.key,
              "title": props.definition.key,
              "options": [],
              "track-by": "id",
              "label": "name",
              "multiple": false,
              "no-result": "Sorry, no images found.",
              "query": _vm.TEMPLATE_IMAGES_QUERY,
              "query-variables": {
                first: 10,
                filters: {
                  name: {
                    value: ['{input}'],
                    modifiers: {
                      matchType: 'contains'
                    }
                  }
                }
              }
            },
            scopedSlots: _vm._u([{
              key: "singleLabel",
              fn: function (props) {
                return [_c('div', {
                  staticClass: "flex items-center"
                }, [_c('YImage', {
                  staticClass: "rounded mr-2",
                  attrs: {
                    "src": props.option.imageThumbnailUrl,
                    "width": 6,
                    "height": 6
                  }
                }), _c('div', [_vm._v(_vm._s(props.option.name))])], 1)];
              }
            }, {
              key: "option",
              fn: function (props) {
                return [_c('div', {
                  staticClass: "flex items-center -mx-2"
                }, [_c('YImage', {
                  staticClass: "rounded mr-2",
                  attrs: {
                    "src": props.option.imageThumbnailUrl,
                    "width": 12,
                    "height": 12
                  }
                }), _c('div', [_vm._v(_vm._s(props.option.name))])], 1)];
              }
            }], null, true),
            model: {
              value: _vm.inputs[props.definition.key],
              callback: function ($$v) {
                _vm.$set(_vm.inputs, props.definition.key, $$v);
              },
              expression: "inputs[props.definition.key]"
            }
          })];
        }
      }], null, true)
    }) : _vm._e()] : _vm._e()], 2);
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }